<template>
    <div class="toTop" @click="totop">
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
        <title>arrow_back_top</title>
        <desc>Created with Sketch.</desc>
        <g
          id="页面-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <g
            id="粒上皇首页"
            transform="translate(-1362.000000, -2379.000000)"
            stroke="#4C0104"
            stroke-width="2"
          >
            <g id="编组-14" transform="translate(1345.000000, 2361.000000)">
              <g id="arrow_back_top" transform="translate(17.000000, 18.000000)">
                <path
                  d="M11.5701109,2.07890557 L19.2279221,9.57890557 L11.5701109,17.0789056 M18,9.5936242 L2,9.5936242"
                  id="形状结合"
                  transform="translate(10.613961, 9.578906) rotate(-90.000000) translate(-10.613961, -9.578906) "
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
</template>

<script>
    export default {
        methods:{
          totop(){
            this.$emit('totop')
          }
        }
    }
</script>

<style lang="scss" scoped>
	.toTop{
		    position: fixed;
		    bottom: 40px;
		    right: 40px;
		    width: 55px;
		    height: 55px;
		    opacity: .9;
		    background: #fbea11;
		    border-radius: 100%;
		    padding: 18px 0 0 0;
		    cursor: pointer;
		    z-index: 100;
		    text-align: center;
			border: 2px solid white;
	}
</style>